var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PackageItemRequirementsModal',_vm._g(_vm._b({},'PackageItemRequirementsModal',{ packageItem: _vm.packageItem, updating: _vm.updating },false),{ submit: _vm.doUpdatePackageItem }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }